// extracted by mini-css-extract-plugin
export default {"root":"Hi5ArixOFcSRrMDDeCDw","small":"hedmjnt_nFLuV3N4UMOv"};